import React, { useState, useEffect } from "react";
import { withRedux, priceToDollars } from "helpers";
import styled, { css } from "react-emotion";
import * as styles from "../../../newStyles.styles";
import WebIcon from "../../WebIcon";

const CheckoutContainer = styled("div")`
  margin: 0 auto;
  max-width: 92.30769rem;
  width: 100%;
  min-height: 15.38462rem;
  padding: 0 1.5rem 7.5rem;
  @media (min-width: 968px) {
    padding-bottom: 1.5rem;
  }
`;

const CheckoutMain = styled("div")`
  padding-left: 1.15385rem;
  padding-right: 1.15385rem;
  width: 100%;
  float: left;
  @media (min-width: 1261px) {
    padding-right: 6rem;
  }
  @media (min-width: 1261px) {
    width: 66.66667%;
  }
  @media (min-width: 968px) {
    width: 58.33333%;
  }
`;

const AsideSummary = styled("aside")`
  @media (min-width: 968px) {
    width: 41.66667%;
  }

  padding-left: 1.15385rem;
  padding-right: 1.15385rem;
  width: 100%;
  float: left;
`;

const ArticleSummary = styled("article")`
  background-color: #fff;
  border-color: #ddd;
  box-shadow: 0 1px 4px rgba(221, 221, 221, 0.6);

  @media (min-width: 968px) {
    display: block;
  }

  border: 1px solid #ebebeb;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(95, 95, 95, 0.14);
  /* display: none; */
  margin: 3rem 0 1.5rem;
  min-height: 300px;
`;

const ArticleHeader = styled("header")`
  display: table;
  padding: 1.5rem;
  width: 100%;
`;

const Section = styled("section")`
  border-top: 1px solid #ebebeb;
  padding: 1.5rem;
  border-color: #ddd;
`;

const SectionRow = styled("div")`
  display: table;
  margin-bottom: 0.75rem;
  width: 100%;
`;

const SectionItem = styled("div")`
  display: table-cell;
  vertical-align: middle;
`;

const inlineBlock = css`
  display: inline-block;
`;

const paraStyle = css`
  text-align: left;
  margin-left: 15px;
`;

function ConfirmWebComponent(props) {
  const [cartState, setcartState] = useState({});

  useEffect(() => {
    // code to run on component mount
    setcartState(props.cart);
    // clear cart after confirmation
    props.actions.removeCart();
  }, []);

  String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  const {
    history: {
      location: {
        state: { clientSecretObject },
      },
    },
  } = props;

  // console.dir(clientSecretObject);

  const renderTotalCalcs = () => {
    return (
      <AsideSummary>
        <ArticleSummary>
          <ArticleHeader>
            <h3
              style={{
                display: "table-cell",
                marginBottom: "0",
                verticalAlign: "middle",
                textAlign: "left",
              }}
            >
              Order Summary
            </h3>
          </ArticleHeader>
          <Section>
            <SectionRow>
              <SectionItem style={{ textAlign: "left" }}>Subtotal</SectionItem>
              <SectionItem style={{ textAlign: "right" }}>
                {priceToDollars(cartState.clientCalculatedSubtotal)}
              </SectionItem>
            </SectionRow>
            {cartState.orderDeliveryType != "PICKUP" &&
              cartState.deliveryCost > 0 && (
                <SectionRow>
                  <SectionItem style={{ textAlign: "left" }}>
                    {cartState.orderDeliveryType.toProperCase()}
                  </SectionItem>
                  <SectionItem style={{ textAlign: "right" }}>
                    {" "}
                    {priceToDollars(cartState.deliveryCost)}
                  </SectionItem>
                </SectionRow>
              )}
          </Section>
          <Section>
            <SectionRow>
              <SectionItem style={{ textAlign: "left" }}>Total</SectionItem>
              <SectionItem
                style={{
                  textAlign: "right",
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  lineHeight: "1.2",
                }}
              >
                {" "}
                {cartState.orderDeliveryType
                  ? priceToDollars(cartState.clientTotal)
                  : priceToDollars(cartState.clientCalculatedSubtotal)}
              </SectionItem>
            </SectionRow>
          </Section>
        </ArticleSummary>
      </AsideSummary>
    );
  };

  const { user } = props.platformInfo.status;
  if (!user) return null;
  return (
    <CheckoutContainer>
      {/* <styles.H3 style={{ margin: "0px", marginBottom: "20px" }}>
        Order Confirmed
      </styles.H3> */}
      <CheckoutMain>
        <p style={{ textAlign: "left", marginBottom: "20px" }}>
          Hey{" "}
          <span style={{ fontWeight: "bold" }}>
            {clientSecretObject.basicUserInfo.firstName}
          </span>
          ,{" "}
        </p>
        <div style={{ display: "flex", alignItems: "center" }}>
          <WebIcon
            iconName={"checkMark"}
            useColor={true}
            size={"100px"}
            hover={false}
            className={inlineBlock}
            customColor={"#4caf50"}
          />
          <p className={paraStyle}>
            Thanks for shopping with us! Your order has been successfully placed
            and processed. We've emailed you a confirmation.{" "}
          </p>
        </div>
      </CheckoutMain>
      {renderTotalCalcs()}
    </CheckoutContainer>
  );
}

export default withRedux(ConfirmWebComponent);
